export default __webpack_public_path__ + "static/media/profile.e30eb201.svg";